import {
    Box,
    Grid,
    Heading,
} from '@theme-ui/components'
import { ArticleRow, Container, Markdown } from '~/Common'
import { useTranslation } from 'react-i18next'

export const NewsLink = ({ bg = 'white', data, container, ...props }) => {
    const { t } = useTranslation();
    const title = data?.title ?? null;
    const description = data?.description ?? null;
    const articles = data?.articles ?? null;

    return (
        <Box bg={bg} {...props}>
            <Container variant="layouts.section" {...container}>
                { title && <Heading as="h2" variant="content_block_heading">{t(title)}</Heading>}
                { description && <Box className="markdown" mb={[4,4,5]}>
                    <Markdown>{description}</Markdown>
                </Box>}

                {articles &&
                    <Grid sx={{
                        gridGap: 0,
                        gridTemplateColumns: ['1fr'],
                        width: '100%'
                    }}>
                        {articles.map((article, key) => (
                            <ArticleRow key={key} article={{
                                ...article,
                                is_external: true,
                            }} />
                        ))}
                    </Grid>
                }
            </Container>
        </Box>
    )
};
